import React from 'react';

import ProfileRecommendationCard from 'buyside/components/presentation/ProfileRecommendationCard/profileRecommendationCard';

const AllocatorProfileCardRecommendation = props => {
  return (
    <ProfileRecommendationCard
      {...props}
      ProfileCard={props.card}
      Profile={props.node.allocatorProfile}
      ProfileType="Allocator"
    />
  );
};

export default AllocatorProfileCardRecommendation;
